<template>
  <div>
    <v-card elevation="0">
      <PotensiMainCarousel></PotensiMainCarousel>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-card
          class="mt-n16 py-2 grey lighten-4 rounded-lg no-gutters"
          elevation="24"
          style="z-index: 2"
        >
          <v-card-actions>
            <v-row no-gutters class="justify-center">
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-on:keyup.enter="searchOnEnter"
                  v-on:blur="searchOnEnter"
                  append-icon="mdi-magnify"
                  outlined
                  dense
                  :hint="$t('hint')"
                  :label="$t('cari')"
                  class="gradient-textfield-bgcolor"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-autocomplete
                  v-model="filterFareaBean"
                  :items="itemsFArea"
                  item-value="id"
                  item-text="description"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Kecamatan"
                  class="ml-1 gradient-textfield-bgcolor"
                  multiple
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-autocomplete
                  v-model="filterFsectorTypeBean"
                  :items="itemsFSectorType"
                  item-value="id"
                  :item-text="lang === 'id' ? 'description' : 'descriptionEn'"
                  outlined
                  dense
                  chips
                  small-chips
                  :label="$t('sektor')"
                  class="ml-1 gradient-textfield-bgcolor"
                  multiple
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-autocomplete
                  v-model="filterFpotensiTypeBean"
                  :items="itemsFPotensiType"
                  item-value="id"
                  :item-text="lang === 'id' ? 'description' : 'descriptionEn'"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Jenis"
                  class="ml-1 gradient-textfield-bgcolor"
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-col>

              <v-col class="ml-2" cols="12" sm="2" md="2">
                <v-btn block dark color="green darken-4" @click="searchOnClick">
                  <v-icon small>mdi-magnify</v-icon>
                  {{ $t("cari") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <v-card class="mx-2 mb-1 rounded-lg">
      <PotensiMainMap
        :itemsFDayaDukung="itemsFDayaDukung"
        :itemsFDayaDukungType="itemsFDayaDukungType"
        :itemsFSectorType="itemsFSectorType"
        :itemsFArea="itemsFArea"
        :itemsFSubArea="itemsFSubArea"
        :itemsFPotensi="itemsFPotensiMarker"
        :itemsFInfrastructureType="itemsFInfrastructureType"
        :itemsFKomoditiType="itemsFKomoditiType"
      ></PotensiMainMap>
    </v-card>

    <v-card class="elevation-0 mt-4 service bg-light text-center">
      <v-card-text>
        <v-row class="py-4 justify-center" v-if="fPotensiFiltered.length < 1">
          <v-col cols="12" align="center">
            <span>{{
              lang === "id" ? "Data Tidak Tersedia" : "No Data Available"
            }}</span>
          </v-col>
        </v-row>

        <v-layout wrap class="d-flex mt-2 justify-center">
          <div v-for="(item, i) in fPotensiFiltered" :key="i">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  max-width="320"
                  xs12
                  sm4
                  px-3
                  class="ma-3 rounded-lg"
                  :elevation="hover ? 16 : 3"
                >
                  <div
                    v-if="
                      item.jenis === 'IPRO' ||
                      item.jenis === 'PELUANG' ||
                      item.jenis === 'POTENSI'
                    "
                  >
                    <v-hover>
                      <template v-slot:default="{ hover }">
                        <router-link
                          style="text-decoration: none"
                          :to="
                            `public-potensi-detail/` +
                            linkNeated(item.id.toString())
                          "
                        >
                          <v-img
                            height="200"
                            :lazy-src="lookupImageUrlLazy(item)"
                            :src="lookupImageUrl(item)"
                            :class="{ 'hover-image': hover }"
                            class="rounded-lg"
                          >
                            <v-card-title class="top-edge mt-n3 mr-n3">
                              <v-spacer></v-spacer>
                              <v-btn
                                v-if="item.jenis === 'IPRO'"
                                small
                                color="rgb(104, 96, 223, 0.8)"
                                class="font-weight-black"
                                >{{
                                  lang === "id" ? item.jenis : $t("potensi")
                                }}</v-btn
                              >
                              <v-btn
                                v-else-if="item.jenis === 'PELUANG'"
                                small
                                color="rgb(33, 131, 25, 0.8)"
                                class="font-weight-black"
                                >{{
                                  lang === "id" ? item.jenis : $t("potensi")
                                }}</v-btn
                              >
                              <v-btn
                                v-else
                                elevation="0"
                                small
                                color="rgb(192, 182, 74, 0.8)"
                                class="font-weight-black"
                                >{{
                                  lang === "id" ? item.jenis : $t("potensi")
                                }}</v-btn
                              >
                            </v-card-title>
                          </v-img>
                        </router-link>
                      </template>
                    </v-hover>
                  </div>

                  <div v-else>
                    <v-hover>
                      <template v-slot:default="{ hover }">
                        <router-link
                          style="text-decoration: none"
                          :to="
                            `public-kawasan-detail/` +
                            linkNeated(item.id.toString())
                          "
                        >
                          <v-img
                            height="200"
                            :lazy-src="lookupImageUrlLazy(item)"
                            :src="lookupImageUrl(item)"
                            :class="{ 'hover-image': hover }"
                            class="rounded-lg"
                          >
                            <v-card-title class="top-edge mt-n3 mr-n3">
                              <v-spacer></v-spacer>
                              <v-btn
                                v-if="item.jenis === 'IPRO'"
                                small
                                color="rgb(104, 96, 223, 0.8)"
                                class="font-weight-black"
                                >{{
                                  lang === "id" ? item.jenis : $t("potensi")
                                }}</v-btn
                              >
                              <v-btn
                                v-else-if="item.jenis === 'PELUANG'"
                                small
                                color="rgb(33, 131, 25, 0.8)"
                                class="font-weight-black"
                                >{{
                                  lang === "id" ? item.jenis : $t("potensi")
                                }}</v-btn
                              >
                              <v-btn
                                v-else
                                elevation="0"
                                small
                                color="rgb(192, 182, 74, 0.8)"
                                class="font-weight-black"
                                >{{
                                  lang === "id" ? item.jenis : $t("potensi")
                                }}</v-btn
                              >
                            </v-card-title>
                          </v-img>
                        </router-link>
                      </template>
                    </v-hover>
                  </div>

                  <v-flex class="d-flex">
                    <v-btn
                      v-if="lookupFSectorType(item.fsectorTypeBean).id > 0"
                      dark
                      class="ml-1 mt-n3 rounded-lg"
                      x-small
                      depressed
                      color="rgb(104, 96, 223, 0.8)"
                      elevation="3"
                      >{{
                        lang === "id"
                          ? lookupFSectorType(item.fsectorTypeBean).description
                          : lookupFSectorType(item.fsectorTypeBean)
                              .descriptionEn
                      }}</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="item.remarkBool1 === true"
                      dark
                      class="ml-1 mt-n3 mr-1 rounded-lg"
                      x-small
                      depressed
                      color="rgb(252, 3, 36, 0.8)"
                      elevation="3"
                      >Perpres-80</v-btn
                    >
                    <!--                  Perpress 80 tahun 2019-->
                  </v-flex>

                  <v-card-text>
                    <div class="subtitle-2" v-if="lang === 'id'">
                      {{ item.kode2 }}
                    </div>
                    <div class="subtitle-2" v-if="lang === 'en'">
                      {{ item.kode2En }}
                    </div>

                    <v-flex class="d-flex mt-1">
                      <span class="caption font-weight-light"
                        >{{ item.district }}, {{ item.city }}</span
                      >
                    </v-flex>

                    <v-flex class="d-flex child-flex mt-1">
                      <div class="d-flex align-baseline">
                        <v-icon x-small>mdi-tag</v-icon>
                        <span class="caption ml-1">{{
                          formatNumberString(item.nilaiInvestasi)
                        }}</span>
                      </div>
                      <div class="d-flex align-baseline">
                        <v-icon x-small>mdi-calendar-range</v-icon>
                        <span class="caption ml-1">{{ item.tahun }}</span>
                      </div>
                      <div class="d-flex align-baseline">
                        <span v-if="item.remarkBool2">
                          <v-icon x-small color="orange">mdi-map</v-icon>
                          <span class="caption ml-1">{{
                            $t("terpetakan")
                          }}</span>
                        </span>
                      </div>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </div>
        </v-layout>

        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="10" md="9" sm="8" align="right">
              <v-pagination
                v-model="currentPage"
                :length="totalPaginationPages"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PotensiMainMap from "@/components/public-potensi/PotensiMainMap";
import FPotensiFilter from "@/models/payload/f-potensi-filter";
import FPotensiService from "@/services/apiservices/f-potensi-service";
import FileService from "@/services/apiservices/file-service";
import EPotensiType, { EPotensiTypes } from "@/models/e-potensi-type";
// import { format, parseISO } from "date-fns";
import PotensiMainCarousel from "@/components/public-potensi/PotensiMainCarousel.vue";

export default {
  name: "PotensiMain",
  props: {
    jenis: String,
    itemsFPotensi: Array,
    itemsFArea: Array,
    itemsFSectorType: Array,
    itemsFSubArea: Array,
    itemsFDayaDukung: Array,
    itemsFDayaDukungType: Array,
    itemsFInfrastructureType: Array,
    itemsFKomoditiType: Array,
  },
  components: {
    PotensiMainCarousel,
    PotensiMainMap,
  },
  data() {
    return {
      EPotensiTypes: EPotensiTypes,
      showInfo: true,
      infoDialogMessage: "",

      currentPage: 1,
      totalTablePages: 1,
      totalPaginationPages: 1,
      pageSize: 9,
      pageSizes: [9, 25, 50, 150, 500],

      search: "",
      filterFareaBean: "",
      filterFsectorTypeBean: "",
      filterFkomoditiTypeBean: "",
      filterFpotensiTypeBean: "",
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "coverImage",
          width: "20%",
        },
        { text: "", value: "title", width: "30%" },
      ],

      formMode: "",
      itemSelectedIndex: -1,
      itemSelected: "",
      itemsFDivision: [],
      itemsFPotensiType:  [
        EPotensiType.IPRO,
        EPotensiType.POTENSI,
        EPotensiType.PELUANG,
      ],
    };
  },
  computed: {
    itemsFPotensiMarker: {
      get() {
        return this.$store.state.potensi.itemsFPotensiMarker;
      },
      set(value) {
        this.$store.dispatch("potensi/updateItemsFPotensiMarker", value);
      },
    },
    lang: {
      get() {
        return this.$store.state.langModule.lang;
      },
      set(val) {
        this.$store.dispatch("langModule/setLang", val);
      },
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    fPotensiFiltered() {
      let potensiesModified = [];
      const listPotensi = this.$store.state.potensi.itemsFPotensi.filter(item => item.statusActive===true);
      for (let i = 0; i < listPotensi.length; i++) {
        let itemBerita = listPotensi[i];
        if (itemBerita.contentBody !== undefined) {
          if (itemBerita.contentBody.length > 100) {
            itemBerita.contentBody = itemBerita.contentBody.substr(0, 99);
          }
        }
        potensiesModified.push(itemBerita);
      }

      return potensiesModified;
    },
  },

  watch: {
    lang: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          // this.fetchFSectorType()
        }
      },
    },
    currentPage: {
      handler: function (value) {
        if (value) this.fetchFPotensi();
      },
    },
    pageSize: {
      handler: function (value) {
        const refreshData = this.currentPage === 1;
        this.currentPage = 1;
        if (refreshData) {
          console.log("Change PageSize " + value);
          this.fetchFPotensi();
        }
        // console.log("page size = " + value + " >> " + this.totalPages)
      },
    },
  },

  methods: {

    async searchOnClick() {
      await this.$store.dispatch("potensi/updateItemsFPotensiMarker", []);
      this.currentPage = 1;
      await this.fetchFPotensi();
      this.itemsFPotensiMarker = this.$store.state.potensi.itemsFPotensi;
    },
    async searchOnEnter(event) {
      if (this.search !== event.target.value) {

        await this.$store.dispatch("potensi/updateItemsFPotensiMarker", []);
        this.currentPage = 1;
        this.search = event.target.value;

        await this.fetchFPotensi();
        this.itemsFPotensiMarker = this.$store.state.potensi.itemsFPotensi;
      }
    },
    fetchParent() {},

    fetchFPotensi() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch("potensi/updateItemsFPotensi", []);

        const fpotensiFilter = new FPotensiFilter();

        fpotensiFilter.pageNo = this.currentPage;
        fpotensiFilter.pageSize = this.pageSize;
        fpotensiFilter.search = this.search;

        fpotensiFilter.jenis = this.filterFpotensiTypeBean;

        fpotensiFilter.fareaIds = this.filterFareaBean;
        fpotensiFilter.fsectorTypeIds = this.filterFsectorTypeBean;
        fpotensiFilter.fkomoditiTypeIds = this.filterFkomoditiTypeBean;

        if (fpotensiFilter.fareaIds.length === 0) fpotensiFilter.fareaIds = [];
        if (fpotensiFilter.fsectorTypeIds.length === 0)
          fpotensiFilter.fsectorTypeIds = [];
        if (fpotensiFilter.fkomoditiTypeIds.length === 0)
          fpotensiFilter.fkomoditiTypeIds = [];

        FPotensiService.getAllFPotensiContainingPublicWithJenisExt(
          fpotensiFilter
        ).then(
          (response) => {
            const { items, totalPages } = response.data;
            this.$store.dispatch(
              "potensi/updateItemsFPotensi",
              items.filter((x) => x.statusActive)
            );

            this.totalPaginationPages = totalPages;
            resolve(); // Resolve the promise here
          },
          (error) => {
            console.log(error.response);
            reject(error); // Reject the promise in case of error
          }
        );
      });
    },

    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },

    getColorStatusActive(trueFalse) {
      if (trueFalse === true) return "green";
      else if (trueFalse === false) return "gray";
      else return "gray";
    },

    lookupFDivision(fdivisionBean) {
      const str = this.itemsFDivision.filter((x) => x.id === fdivisionBean);
      if (str.length > 0) {
        return str[0].description;
      } else {
        return "-";
      }
    },
    lookupFSectorType(fsectorTypeBean) {
      const str = this.itemsFSectorType.filter((x) => x.id === fsectorTypeBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
    lookupFKomoditiType(fkomoditiTypeBean) {
      const str = this.itemsFKomoditiType.filter(
        (x) => x.id === fkomoditiTypeBean
      );
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },

    lookupFArea(fareaBean) {
      const str = this.itemsFArea.filter((x) => x.id === fareaBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },

    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_low(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    computedDateFormattedDatefns(value) {
      // return value ? format(parseISO(value), "dd-MMM-yyyy") : "";
      return value ? new Date(value).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "";
    },
    dateTimeFormat(value) {
      // return value ? format(parseISO(value), "dd-MMM-yyyy hh:mm:ss") : "";
      return value ? new Date(value).toLocaleString() : "";
    },
    formattedCurrencyValue(prefix, value) {
      if (!value) {
        return "0";
      }
      // return "Rp." + parseFloat(value).toFixed(0).toLocaleString()
      return prefix + "" + parseFloat(value).toLocaleString();
    },
    formatNumberString(value) {
      let valueStr = "";
      if (value / 1000000000 > 1) {
        valueStr = `${parseFloat(value / 1000000000).toLocaleString()} Miliar`;
      } else if (value / 1000000 > 1) {
        valueStr = `${parseFloat(value / 1000000).toLocaleString()} Juta`;
      } else if (value / 1000 > 1) {
        valueStr = `${parseFloat(value / 1000).toLocaleString()} Ribu`;
      } else {
        valueStr = value.toString();
      }
      return valueStr;
    },
  },

  mounted() {
    this.fetchParent();
    this.fetchFPotensi();
  },
};
</script>

<style scoped>
</style>